export const MIN_GUESTS = 1;
export const MAX_GUESTS = 10;

export const MIN_BEDROOMS = 0;
export const MAX_BEDROOMS = 4;

export const MIN_BATHROOMS = 1;
export const MAX_BATHROOMS = 4;

export const MIN_BEDS = 1;
export const MAX_BEDS = 4;

export const DEFAULT_AMENITIES = {
  bedroom_count: 0,
  bed_count: 1,
  bathroom_count: 1,
};

export const userRoutes = {
  my_stays: "/profile",
  my_profile: "/accounts/edit",
  edit_profile: "/accounts/edit",
  log_out: "/accounts/sign_out",
  dev_tools: "/dev-tools",
};

export const MAX_TITLE_LENGTH = 37;
export const NON_MEMBER_PRICE_MULTIPLIER = 1 / 0.85;
export const MEMBER_PRICING_EXPERIMENT_MULTIPLIER = 1.059;
export const MAX_LISTINGS_PER_CITY = 1000;
export const DEFAULT_MAP_DIMENSION = { width: 373, height: 826 };
export const DEFAULT_GUESTS = 1;

export const IOS_URL =
  "https://itunes.apple.com/app/apple-store/id1422914567?pt=119113931&ct=sondercom&mt=8";

export const ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.sonder.mahalo&referrer=utm_source%3Dsondercom";

// List from Persona: https://docs.withpersona.com/v2021-08-18/docs/languages for the v3.11.0 version
export const PERSONA_SUPPORTED_LANG = [
  "ar-EG",
  "de",
  "en-US",
  "es-MX",
  "fr",
  "id-ID",
  "it",
  "ja",
  "ko-KR",
  "nl-NL",
  "pl",
  "pt-BR",
  "ro",
  "ru",
  "th",
  "tr-TR",
  "uk-UA",
  "zh-CN",
  "zh-TW",
];
